var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.011,
    height: 25.545,
    viewBox: "0 0 20.011 25.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ppt-svgrepo-com",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14206",
    "data-name": "Trazado 14206",
    d: "M48.6,0H32.842V25.545H52.853V4.257Z",
    transform: "translate(-32.843)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_471",
    "data-name": "Grupo 471",
    transform: "translate(4.891 5.199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1615",
    "data-name": "Rect\\xE1ngulo 1615",
    width: 10.101,
    height: 10.101,
    transform: "translate(0)",
    fill: "#ff671b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1616",
    "data-name": "Rect\\xE1ngulo 1616",
    width: 8.349,
    height: 8.349,
    transform: "translate(0.876 0.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_470",
    "data-name": "Grupo 470",
    transform: "translate(2.082 2.568)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1617",
    "data-name": "Rect\\xE1ngulo 1617",
    width: 5.937,
    height: 4.965,
    fill: "#ff671b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1618",
    "data-name": "Rect\\xE1ngulo 1618",
    width: 5.044,
    height: 0.641,
    transform: "translate(0.447 0.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14207",
    "data-name": "Trazado 14207",
    d: "M122.177,112.472a1.26,1.26,0,1,0,1.26,1.26h-1.26Z",
    transform: "translate(-120.47 -110.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1619",
    "data-name": "Rect\\xE1ngulo 1619",
    width: 1.927,
    height: 0.374,
    transform: "translate(3.563 1.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1620",
    "data-name": "Rect\\xE1ngulo 1620",
    width: 1.927,
    height: 0.373,
    transform: "translate(3.563 2.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1621",
    "data-name": "Rect\\xE1ngulo 1621",
    width: 1.927,
    height: 0.373,
    transform: "translate(3.563 3.39)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14208",
    "data-name": "Trazado 14208",
    d: "M49.255,2.129H32.842V0H48.6Z",
    transform: "translate(-32.843)",
    fill: "#ff671b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_472",
    "data-name": "Grupo 472",
    transform: "translate(5.128 19.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14209",
    "data-name": "Trazado 14209",
    d: "M96.646,227.178a1.354,1.354,0,0,1-.4,1.047,1.612,1.612,0,0,1-1.135.369H94.8v1.341H93.712v-4.042h1.4a1.71,1.71,0,0,1,1.15.335A1.193,1.193,0,0,1,96.646,227.178ZM94.8,227.7H95a.544.544,0,0,0,.391-.138.5.5,0,0,0,.145-.382q0-.409-.453-.409H94.8Z",
    transform: "translate(-93.712 -225.892)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14210",
    "data-name": "Trazado 14210",
    d: "M139.112,227.178a1.354,1.354,0,0,1-.4,1.047,1.612,1.612,0,0,1-1.135.369h-.307v1.341h-1.092v-4.042h1.4a1.71,1.71,0,0,1,1.15.335A1.193,1.193,0,0,1,139.112,227.178Zm-1.841.525h.2a.544.544,0,0,0,.391-.138.5.5,0,0,0,.145-.382q0-.409-.454-.409h-.282Z",
    transform: "translate(-132.6 -225.892)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14211",
    "data-name": "Trazado 14211",
    d: "M177.212,229.934H176.12v-3.149h-.987v-.893H178.2v.893h-.984v3.149Z",
    transform: "translate(-168.273 -225.892)",
    fill: "#a4a9ad"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14212",
    "data-name": "Trazado 14212",
    d: "M219.821,4.257h4.257L219.821,0Z",
    transform: "translate(-204.068)",
    fill: "#d1d3d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.561d55eee8f842d57781cd0bc4f1197a.svg";
export { ForwardRef as ReactComponent };